const SHOW_DELAY = 120 // мс: не мигать на мгновенных/кэшированных переходах
const REQUEST_TIMEOUT = 20000
const OFFLINE_MSG = "Нет соединения. Проверь интернет и попробуй снова."
const ERROR_MSG = "Что-то пошло не так. Попробуй ещё раз."

const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches

let bar = null
let active = 0
let shown = false
let startTimer = null
let trickleTimer = null

function ensureBar() {
  if (bar) return bar

  bar = document.createElement("div")
  bar.id = "top-progress"
  bar.className = "bg-accent"
  Object.assign(bar.style, {
    position: "fixed",
    top: "0",
    left: "0",
    height: "3px",
    width: "0%",
    opacity: "0",
    zIndex: "100",
    pointerEvents: "none",
    boxShadow: "0 0 8px var(--color-accent)",
    transition: reduced ? "opacity .2s ease" : "width .2s ease, opacity .3s ease"
  })
  document.body.appendChild(bar)
  return bar
}

function setWidth(percent) {
  ensureBar().style.width = `${percent}%`
}

function currentWidth() {
  return Number.parseFloat(bar?.style.width) || 0
}

function trickle() {
  clearTimeout(trickleTimer)
  trickleTimer = setTimeout(() => {
    const cur = currentWidth()
    if (cur < 90) {
      setWidth(Math.min(90, cur + (Math.random() * 10 + 2)))
      trickle()
    }
  }, 400)
}

function start() {
  clearTimeout(startTimer)
  startTimer = setTimeout(() => {
    shown = true
    ensureBar().style.opacity = "1"
    if (reduced) {
      setWidth(100)
    } else {
      setWidth(10)
      trickle()
    }
  }, SHOW_DELAY)
}

function reset() {
  shown = false
  if (!bar) return
  bar.style.transition = "none"
  setWidth(0)
  void bar.offsetWidth // reflow, чтобы сброс ширины не анимировался
  bar.style.transition = reduced ? "opacity .2s ease" : "width .2s ease, opacity .3s ease"
}

function done() {
  clearTimeout(startTimer)
  clearTimeout(trickleTimer)
  if (!bar || !shown) {
    // запрос завершился быстрее SHOW_DELAY — не мигаем полосой
    reset()
    return
  }
  setWidth(100)
  setTimeout(() => {
    bar.style.opacity = "0"
    setTimeout(reset, 300)
  }, 150)
}

// Иконка как у флеша ошибки (Tabler alert-circle, size 32).
const ALERT_ICON = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-alert-circle" width="32" height="32">
  <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
  <path d="M12 8v4"></path>
  <path d="M12 16h.01"></path>
</svg>`

// Показываем ошибку в том же виде, что и серверный flash (shared/_flash.erb):
// та же разметка + data-controller="flash" — flash-контроллер сам анимирует и скроет.
function showFlash(message) {
  let container = document.getElementById("flash")
  if (!container) {
    container = document.createElement("div")
    container.id = "flash"
    document.body.appendChild(container)
  }

  const el = document.createElement("div")
  el.setAttribute("role", "alert")
  el.className =
    "alert alert-soft alert-error border-error fixed bottom-4 left-1/2 z-50 w-fit -translate-x-1/2 transition-all duration-300 ease-out hover:scale-[1.03]"
  el.dataset.controller = "flash"
  el.dataset.flashTimeoutValue = "5000"
  el.dataset.flashTarget = "message"
  el.dataset.action = "mouseenter->flash#pause mouseleave->flash#resume"
  el.insertAdjacentHTML("beforeend", ALERT_ICON)

  const span = document.createElement("span")
  span.className = "text-xl"
  span.textContent = message
  el.appendChild(span)

  container.appendChild(el)
}

function init() {
  const body = document.body
  if (!body) return

  // дефолтный таймаут на все запросы
  body.addEventListener("htmx:configRequest", (e) => {
    e.detail.timeout = REQUEST_TIMEOUT
  })

  // полоса прогресса
  body.addEventListener("htmx:beforeRequest", () => {
    active += 1
    if (active === 1) start()
  })
  body.addEventListener("htmx:afterRequest", () => {
    active = Math.max(0, active - 1)
    if (active === 0) done()
  })

  // ошибки/оффлайн
  body.addEventListener("htmx:sendError", () => showFlash(OFFLINE_MSG))
  body.addEventListener("htmx:timeout", () => showFlash(OFFLINE_MSG))
  body.addEventListener("htmx:responseError", () => showFlash(ERROR_MSG))
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init, {once: true})
} else {
  init()
}
